var _defs, _ellipse, _ellipse2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _path, _rect9, _rect10, _path2, _path3, _path4, _path5, _ellipse3, _path6, _path7, _path8, _path9, _rect11, _rect12, _rect13, _rect14, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect15, _rect16, _rect17, _rect18, _path19, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "generic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.28 383.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aed3ff;}.cls-2{fill:#00479b;}.cls-3{fill:#fff9eb;}.cls-4{fill:#006aea;}.cls-5{fill:#75b2fc;}.cls-6{fill:#fff;}.cls-7{fill:#2e83ea;}.cls-8{fill:#fab06d;}.cls-9{fill:#e2bf71;}.cls-10{fill:#1c3d18;}.cls-11{fill:#cadef3;}.cls-12{fill:#f0f4fa;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 147.95,
    cy: 51.45,
    rx: 53.44,
    ry: 51.45
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 150.95,
    cy: 54.67,
    rx: 53.44,
    ry: 51.45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2483.16,
    y: 154.79,
    width: 66.79,
    height: 97.65,
    rx: 12.94,
    transform: "translate(2653.8 678.35) rotate(-171.39)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2481.34,
    y: 155.8,
    width: 66.79,
    height: 94.03,
    rx: 12.3,
    transform: "matrix(-0.99, -0.15, 0.15, -0.99, 2650.3, 676.48)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2490.05,
    y: 193.95,
    width: 51.43,
    height: 4.18,
    transform: "translate(2653.36 663.15) rotate(-171.39)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2488.63,
    y: 203.31,
    width: 51.43,
    height: 4.18,
    transform: "translate(2649.14 681.56) rotate(-171.39)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2487.21,
    y: 212.65,
    width: 51.43,
    height: 4.18,
    transform: "translate(2644.92 699.93) rotate(-171.39)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2500.2,
    y: 166.61,
    width: 39.4,
    height: 4.18,
    transform: "translate(2665.68 609.41) rotate(-171.39)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2486.51,
    y: 222.23,
    width: 48.15,
    height: 12.48,
    rx: 2.42,
    transform: "translate(-2258 -476.51) rotate(8.61)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2493.67,
    y: 177.28,
    width: 48.15,
    height: 7.79,
    rx: 2.3,
    transform: "translate(-2265 -478.11) rotate(8.61)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 95.64,
    cy: 42.31,
    r: 13.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2418,184.81l1-16.71-3.28-14.52A9.69,9.69,0,0,1,2423,142l40.92-9.22a9.69,9.69,0,0,1,11.58,7.31l3.81,16.93A9.69,9.69,0,0,1,2472,168.6l-34.82,7.84-18.06,9.1A.77.77,0,0,1,2418,184.81Z",
    transform: "translate(-2320.48 -103.29)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2425.18,
    y: 146.84,
    width: 39.53,
    height: 5.24,
    transform: "translate(2552.61 -276.61) rotate(168.93)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2427.4,
    y: 157.84,
    width: 39.53,
    height: 2.62,
    transform: "matrix(-0.98, 0.19, -0.19, -0.98, 2558.88, -257.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2577.14,248.26c4.83-8.25,6.87-20.7,1.18-23.93-4.58-2.59-13.13,1.34-18.22,7.32-5.43,6.38-3.66,11.28-10.24,21-5.82,8.61-11.23,10.74-11.2,12.65C2538.74,269.63,2566.4,266.64,2577.14,248.26Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2325.91,404.57a28.9,28.9,0,0,1-2.9-5A28.37,28.37,0,0,1,2337.09,362l.88-.37a38.53,38.53,0,0,1,57.1-41.36c.43-1.42,4.19-13.13,15.33-17.38,10.48-4,19.95,1.5,24.81,4.33a35.09,35.09,0,0,1,14.62,16.57,66.72,66.72,0,0,1,24.5,6.21c3,1.41,10.73,5.13,15.1,10.57,8.67,10.8,5.29,30-6.33,48.38a20.19,20.19,0,0,1-4.32,4.24c-13,9.32-32.38-2.05-36.9-4.85-1.28,2.46-9.8,18.27-29.31,23.81a47.49,47.49,0,0,1-36.15-4.4c-1.91,1.28-19.79,12.91-37.67,5.95A32.91,32.91,0,0,1,2325.91,404.57Zm88.56-46,3.41-1.53a27.51,27.51,0,0,1-3.24-.71C2414.6,357,2414.55,357.79,2414.47,358.53Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2457,255.36c4.3,1.29,12.15,6.29,12.89,12.78,0,0,0,.35,0,.73.26,7.77-16.91,37-45.21,37.91-2.81.09-19.72.37-30.12-11.37a25,25,0,0,1-6.38-13.11c-1.07-7.59,1.48-17.82,7.19-19.78,6.7-2.3,10.26,9.35,21.21,10.87C2433.29,275.72,2443.19,251.24,2457,255.36Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2334.72,367.45a25.8,25.8,0,0,1-.36-4.35c0-11.84,7.95-21.44,17.76-21.44l.6,0a30.83,30.83,0,0,1,8.45-16.39c4.3-4.21,8.49-5.15,15.32-6.55a38.08,38.08,0,0,1,15.4-.55,41.31,41.31,0,0,1,17.81,8.24c.55-.28,7-3.46,12.33,1.9s5.23,14.89,5.21,16.77a28,28,0,0,1-.5,5c.58-.05,1.15-.09,1.73-.09,12.59,0,22.8,12.32,22.8,27.52,0,15-9.88,27.12-22.19,27.51a14.36,14.36,0,0,1-7.47,2.13c-.9,1-12,12.33-25.15,6.09-10.35-4.9-14.72-17.2-15.51-19.55-1.93,2.61-12.57,16.51-24.07,12.72a14.94,14.94,0,0,1-4.06-2.11,15.39,15.39,0,0,1-8.84,2.85c-9.81,0-17.77-9.6-17.77-21.44C2326.21,378,2329.62,371.22,2334.72,367.45Z",
    transform: "translate(-2320.48 -103.29)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 2380.12,
    cy: 236.54,
    rx: 5.59,
    ry: 2.67,
    transform: "translate(-304.34 2497.25) rotate(-86.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2415.32,332l-50.48,5.63c-1-7.7-2.29-19.1-3.14-33-1.62-26.49.25-31,2.9-34.33,8-9.9,26.51-12.38,36.23-4.82,4,3.13,5.93,7.5,8.9,23.12A366.06,366.06,0,0,1,2415.32,332Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2513.71,384.51c-.21,12-11.05,25.5-20.95,25.47-14.38,0-15.84-28.59-37.6-33.36-7.47-1.64-23.61-1.85-30.19-1.93-1,0-4.45-.05-9.07-.27-1.37-.06-8.32-.4-12.53-.94-2-.25-21.8-3-31.07-16.38-.47-.68-.85-1.3-1.09-1.68a45.5,45.5,0,0,1-6.37-17.81l30.94-3.45a113.59,113.59,0,0,1,19.54-2.18c7.38-.16,16.21.4,27.42,1.11l.78.05c3,.24,10.79,1.44,25.18,9.22C2491.14,354.48,2514,366.85,2513.71,384.51Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2445.94,441.51c-8.63,9.14-33.72,4.83-38.17-5.82-2.77-6.63,4.6-10.56,7.12-26.67.94-6,3.75-23.87-5.34-31.53-6-5.07-12-1.19-24.64-8.14a46.67,46.67,0,0,1-10.26-7.5c-12-12.19-9.92-31.87-9.2-37.22l49.14-1.63a82.74,82.74,0,0,0,2,9,34.84,34.84,0,0,0,1.16,3.83c2.09,4.56,5.55,5.12,12.3,11.22l3.75,3.64c7.14,6.95,9.69,9.5,12.49,13.44,0,0,.66.89,1.2,1.76,3.67,5.93,3.85,42.49,3.85,42.49h0C2451.3,424,2451.3,435.84,2445.94,441.51Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2350.4,364.85c2.17-3.58,10.88-4,15.17.72,3.9,4.29,3.32,11.62-.72,15.16-3.09,2.71-8.39,3.36-10.68,1.19-1.44-1.37-.64-2.83-1.65-8C2351.31,367.77,2349.41,366.48,2350.4,364.85Z",
    transform: "translate(-2320.48 -103.29)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2358.14,
    y: 379.21,
    width: 5.73,
    height: 17.89,
    rx: 2.86,
    transform: "translate(2060.2 1567.79) rotate(-156.91)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2361.52,
    y: 374.54,
    width: 5.92,
    height: 17.89,
    rx: 2.96,
    transform: "translate(2323.7 1015.61) rotate(-171.33)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2354.49,
    y: 381.7,
    width: 5.73,
    height: 10.75,
    rx: 2.86,
    transform: "translate(1923.03 1749.85) rotate(-151.47)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2351.18,
    y: 378.73,
    width: 5.73,
    height: 6.82,
    rx: 2.86,
    transform: "translate(1919.17 1739) rotate(-151.47)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2398.08,242.05c.37,5.09-6.9,12-14.95,12.42-6.8.32-13.94-4.07-15.13-9.18-.53-2.3.6-2.75.44-8.44-.13-4.66-.93-5.62-.17-8,.86-2.72,2.76-4.33,4.85-6.09,2.42-2,4.75-4,8.34-4.42a12.33,12.33,0,0,1,10.4,3.87,12.49,12.49,0,0,1,2.58,4.8c.89,3,.07,4.23.49,7.25C2395.56,238.77,2397.89,239.29,2398.08,242.05Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2396.34,228.27c-4.51-1.22-9.38-1.73-11.82.89s-1.74,7.86-2.77,7.94-1.73-4.83-3-4.81-.88,4.83-3.84,8.45a14.84,14.84,0,0,1-6.95,4.55c-.38-.62-5.69-9.48-1.65-17.9,3.59-7.48,11.83-9,16.86-9.91,4.61-.84,6.58,0,7.29.36C2395.52,220.34,2396.25,227.31,2396.34,228.27Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2374.31,354.7c-4.2,7.22-21.13,8.07-27.89.3-1.65-1.91-2.69-5.55-4.75-12.84a63,63,0,0,1-2.64-15.73s-.09-2.69.07-5.23c.55-8.79,4.84-16.55,10.83-28,5.4-10.29,9.59-18.6,16.18-26.28,1.94-2.26,5.13-5.81,9.5-6.05a12.58,12.58,0,0,1,6.17,1.46,17.36,17.36,0,0,1,7.91,8.64c2.56,5.59,1.77,13.06-10.87,38.53-5.66,11.41-7.12,11.26-8.05,16.2C2368,340.42,2378.27,347.9,2374.31,354.7Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2418.7,472.43l-19.48-11.86a88.56,88.56,0,0,0,5.78-8.65c3.33-5.67,3.56-7.46,5.52-8.08,3.47-1.08,5.41,3.65,13.53,6.25,5.08,1.63,8.15,1,8.6,2.53.53,1.81-3.56,3.6-7.43,7.83A29.59,29.59,0,0,0,2418.7,472.43Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2424.07,485.73c-2.76,2.78-13.71-3.62-19.53-7.73-9.39-6.63-9.8-9.17-9.78-10.11,0-1.75,1.07-2.61,4.46-7.32,2.38-3.3,4.17-6.06,5.26-7.79a201.54,201.54,0,0,1,15.64,17.56c1.32,1.66,2.59,3.31,3.82,5a17.59,17.59,0,0,1,.92,5.59C2424.86,483.52,2424.86,484.94,2424.07,485.73Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2545.65,411.84,2534.4,433.2a98.22,98.22,0,0,0-9.52-5.54c-6.21-3.14-8.12-3.26-8.9-5.3-1.37-3.58,3.5-5.95,5.72-14.7,1.38-5.47.52-8.67,2.1-9.25,1.88-.68,4,3.52,8.77,7.33A31.32,31.32,0,0,0,2545.65,411.84Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2559.35,405.3c3.12,2.73-2.92,14.72-6.89,21.14-6.38,10.35-9,10.95-10,11-1.84.07-2.83-.95-8-4.23-3.65-2.29-6.67-4-8.57-5a212.14,212.14,0,0,1,17.52-17.68q2.49-2.25,5-4.36a18.73,18.73,0,0,1,5.84-1.34C2557,404.61,2558.46,404.52,2559.35,405.3Z",
    transform: "translate(-2320.48 -103.29)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2367.93,397.48",
    transform: "translate(-2320.48 -103.29)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2465,250.32c-.78,4.11,5.4,10.26,11.74,9.63,5.77-.58,10.25-6.41,9.62-11.75-.48-4.08-4-8.11-7.14-8-2,.05-2.37,1.68-6.56,4.82C2467.59,248.77,2465.31,248.45,2465,250.32Z",
    transform: "translate(-2320.48 -103.29)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2485.57,
    y: 231.16,
    width: 5.73,
    height: 17.89,
    rx: 2.86,
    transform: "matrix(-0.95, -0.32, 0.32, -0.95, 2443.65, 1171.78)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2484.93,
    y: 236.96,
    width: 5.92,
    height: 17.89,
    rx: 2.96,
    transform: "translate(2110.02 1716.27) rotate(-146.64)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2482.14,
    y: 233.09,
    width: 5.73,
    height: 10.75,
    rx: 2.86,
    transform: "translate(2525.19 947.15) rotate(-166.5)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2476.37,
    y: 236.51,
    width: 5.73,
    height: 6.82,
    rx: 2.86,
    transform: "translate(2513.49 948.67) rotate(-166.5)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2505.4,151.22",
    transform: "translate(-2320.48 -103.29)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 45.87,
    cy: 124.1,
    r: 6.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/Generic.cdf8a0053e918e1b97c6e8a7e336ae23.svg";
export { ForwardRef as ReactComponent };